/** The theme's chart ramp (`app/globals.css`), which already flips for dark mode. */
export const CHART_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
];

const ISO_LIKE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

/**
 * One x-axis label.
 *
 * A time series arrives as offset-aware ISO strings (`2026-09-10T06:00:00+00:00`)
 * and a breakdown as plain keys (`FR`). Only the first is reformatted, and only
 * when it really parses — a category that merely looks datish stays as typed.
 */
export function formatCategory(value: string | number): string {
  if (typeof value === 'number') return String(value);
  if (!ISO_LIKE.test(value)) return value;

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  return parsed.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
